import { CSSObject } from '@chakra-ui/react';
import { EWithdrawalStatus } from '@/lib/DBModels';
import { TWithdrawalStatus } from '../RequestedWithdrawalCard/styles/RequestedWithdrawalCard.styles';
import { CustomButtonProps } from '@/components/Button/Button';

export const Heading: CSSObject = {
  fontSize: 'sm',
  mb: '1',
};

export const DividerWithdrawal: CSSObject = {
  borderBottom: '1px solid',
  boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.07)',
  borderBottomColor: 'blackAlpha.400',
  borderStyle: 'dashed',
};

export const WithdrawalCardContent: CSSObject = {
  color: 'white',
};

export const TextDescription: CSSObject = {
  fontSize: 'xs',
};

export const buttonAddAccountProps: CustomButtonProps = {
  variant: 'solid',
  lineHeight: 'normal',
  w: 'full',
  mb: '2',
};

export const ButtonWithdrawal: CSSObject = {
  variant: 'secondary',
  fontWeight: 'normal',
};

export const ButtonIncrease: CSSObject = {
  variant: 'secondary',
};

export const InputWrapperWithdrawal: CSSObject = {
  '.chakra-form__helper-text': {
    bg: 'gamma.600',
    boxShadow:
      '0px 2px 4px 0px rgba(0, 0, 0, 0.2), 0px 1px 0px 0px rgba(255, 255, 255, 0.2) inset',
    color: 'blackAlpha.700',
    borderRadius: 'base',
    py: '1',
    px: '2',
    fontSize: '2xs',
    fontWeight: 'semibold',
  },
};

export const AmountInputWrapperWithdrawal: CSSObject = {
  '&&': {
    '.chakra-input__group': {
      borderRadius: 'base',
      border: 'none',
      bg: 'blackAlpha.700',
      boxShadow:
        '0px 1px 0px 0px rgba(255, 255, 255, 0.25), 0px 3px 6px 0px rgba(0, 0, 0, 0.2) inset',
      _hover: {
        '&&': {
          border: '1px solid',
          borderColor: 'transparent',
          bg: 'whiteAlpha.400',
          boxShadow: 'none',
        },
      },

      _focus: {
        '&&': {
          border: '1px solid',
          borderColor: 'gamma.100',
          boxShadow: 'none',
        },
      },

      '&:-webkit-autofill': {
        caretColor: 'currentColor',
        '&:hover, &:focus, &:active': { caretColor: 'currentColor' },
      },
    },
    '.chakra-input__left-addon': {
      bgGradient: ' linear(to-b, #FFBF36, #EEA200)',
      h: 9,
      w: 9,
      border: 'none',
      fontWeight: 'bold',
      boxShadow: 'none',
      mt: 1,
      ml: 1,
      p: '14px',
    },
    '#amount-input': {
      bg: 'transparent',
      border: 'none',
      borderLeftRadius: 'none',
      borderRightRadius: 'base',
      boxShadow: 'none',
      h: '44px',
    },
  },
};

/**
 * Bank Account Radios
 */
export const BankRadioWrapper: CSSObject = {
  w: 'full',
  alignItems: 'center',
  justifyContent: 'space-between',
  py: '3',
  px: '2',
  borderBottom: '1px dashed',
  boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.07)',
  borderBottomColor: 'blackAlpha.400',
};

export const BankRadio: CSSObject = {
  bg: 'white',
  '&[data-checked]': {
    boxShadow: 'none',
    bg: 'gamma.500',
    border: '3px solid',
    borderColor: 'white',
    _hover: {
      bg: 'alpha.200',
      borderColor: 'white',
    },
    _before: {
      display: 'none',
      content: 'unset',
    },
  },
};

export const BankCardContainer: CSSObject = {
  mt: '-3',
  bg: 'transparent',
};

export const FlexBankDetailsContainer: CSSObject = {
  fontSize: 'sm',
};

export const TextBankAccountDetail: CSSObject = {
  '.chakra-checkbox__control': {
    bg: 'white',
  },
  '.chakra-checkbox__control[data-checked]': {
    bg: 'black',
  },
};

/**
 * Withdrawal Requests Aside
 */
export const ListContainer: CSSObject = {
  bg: 'alpha.500',
  borderRadius: 'lg',
  boxShadow:
    '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 1px 5px 0px rgba(0, 0, 0, 0.25) inset',
  mt: '3',
  px: '2',
  py: '0',
  w: '100%',
};

export const ListContainerHeading: CSSObject = {
  textTransform: 'uppercase',
  fontFamily: 'accent',
  fontSize: 'lg',
  fontWeight: 'bold',
  mt: '3',
};

/**
 * Withdrawal Request Card
 */
export const TextBankAccountName: CSSObject = {
  fontSize: 'sm',
  fontWeight: 'bold',
};

export const WithdrawalCardDetail: CSSObject = {
  borderBottom: '1px dashed',
  borderColor: 'gray.500',
  py: '1.5',
  fontSize: 'xs',
  fontWeight: 'bold',
};

export const WithdrawalStatus = ({ status }: TWithdrawalStatus): CSSObject => ({
  px: '1',
  py: '0.5',
  borderRadius: 'base',
  bg: status === EWithdrawalStatus.Pending && 'beta.300',
  color: status === EWithdrawalStatus.Pending && 'blackAlpha.800',
  textTransform: 'uppercase',
  fontSize: '2xs',
  lineHeight: 'normal',
});

export const CardTitleWithdrawal: CSSObject = {
  borderBottom: '1px dashed',
  borderColor: 'gray.300',
  fontSize: 'sm',
  fontWeight: 'semibold',
};

export const IncreaseAmountWrapper: CSSObject = {
  mb: '3',
};

export const buttonWithdrawalProps: CustomButtonProps = {
  mt: '2',
  variant: 'solid',
  fontWeight: 'bold',
  h: '26px',
  lineHeight: 1,
};

export const ButtonWithdrawalCardCancel: CSSObject = {
  borderRadius: 'md',
  bg: 'transparent',
  border: '2px',
  borderColor: 'beta.400',
  color: 'white',
  fontFamily: 'accent',
  fontSize: 'sm',
  fontWeight: 'bold',
  textTransform: 'capitalize',
  textShadow: 'none',
  boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.25)',
  _hover: {
    border: '2px',
    borderColor: 'white',
    color: 'beta.300',
    boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.25)',
  },
  ':active, &[data-active=true]': {
    bg: 'blackAlpha.500',
    boxShadow:
      '0px 2px 0px 0px rgba(0, 0, 0, 0.3) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.08)',
    color: 'beta.400',
    textShadow: 'none',
    border: 'none',
  },
  _disabled: {
    opacity: 0.4,
    pointerEvents: 'none',
  },

  '&&&': {
    '& > svg, & > span': { zIndex: 9 },
  },
};

export const FlexWithdrawalWrapper: CSSObject = {
  flexDir: 'column',
};

export const WithdrawalWrapper: CSSObject = {
  p: '2',
  bg: 'transparent',
  bgGradient:
    'linear(to-b, rgba(255, 255, 255, 0.12), rgba(255, 255, 255, 0.05))',
  borderStyle: '1px solid',
  borderColor: 'rgba(255, 255, 255, 0.16)',
  boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.25)',
};

export const WithdrawalCardDetailNumber: CSSObject = {
  borderBottom: '1px solid',
};

export const WithdrawalCardDetailRequested: CSSObject = {
  borderBottom: '1px dashed',
  boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.1)',
  borderBottomColor: 'blackAlpha.500',
};

export const InputWithdrawal: CSSObject = {
  '&&': {
    border: 'none',
    bg: 'blackAlpha.400',
    borderRadius: 'md',
    color: 'white',
    '&:hover': {
      bg: 'blackAlpha.500',
    },
    '&:focus': {
      bg: 'blackAlpha.500',
    },
  },
};
